import { PriceOfferRow } from 'components/tables/data/price-offer/types';
import P2Medium from 'components/typography/P2Medium';

/**
 * Column for the device ID.
 */
export default function DeviceIdColumn({ data }: { data: PriceOfferRow }) {
  return <P2Medium color="gray.8">{data.device.deviceId}</P2Medium>;
}
